import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Atelier de Hoteles Own System **
 *
 * @exports bs_313
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
    * @memberOf module:bs_313
    * @see {@link language_check}
    *
    * @param {object} ctx - The context object.
    */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve) {
            // On Atelier homepages the only thing we can use to detect the language is the hostname
            //  en -> https://atelierdehoteles.com/estudio-playa-mujeres
            //  es -> https://atelierdehoteles.com.mx/estudio-playa-mujeres
            if (thn.data.accountUserId === 1037628 && window.location.hostname.match(/atelierdehoteles\.com\.mx$/)) {
                resolve('es');
                return;
            }
            const aux = (document.querySelector('.dropdown-toggle.nav-link.text-white') || {}).textContent;
            if (aux === ('ESP')) {
                resolve('es');
                return;
            }
            resolve('en');
        });
    };
    /**
       * @memberOf module:bs_313
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const dataLayer = window.dataLayer;
        // Dates
        const dates = ((document.querySelector('input.input-barra') || {}).value || '').split('-');
        // Depending of the language we are seeing the page, the dates format changes
        const dateFormatStr = thn.data.language === 'es' ? '$3/$2/$1' : '$3/$1/$2';
        const checkin = thn.objectGet(dataLayer, 'checkin-date')?.replace(/-/g, '/') || (dates[0])?.replace(/(\d+)\D+(\d+)\D+(\d+)/, dateFormatStr)?.trim();
        const checkout = thn.objectGet(dataLayer, 'checkout-date')?.replace(/-/g, '/') || (dates[1])?.replace(/(\d+)\D+(\d+)\D+(\d+)/, dateFormatStr)?.trim();
        let nights;
        if (checkin && checkout) {
            widgetData.date_begin = checkin || translateDate(checkin, thn.data.language);
            widgetData.date_end = checkout || translateDate(checkout, thn.data.language);
            nights = thn.daysBetween(widgetData.date_begin, widgetData.date_end);
        }
        /**
             * This BE allows multiple rooms case, but, by the way is done, the best we can do is to ignore them
             * and always work as if it was single rooms
             * For that reason, we need to create an object for each rate, storing its price and occupancy
             * Once we have all the data, we should get the room object that has a cheaper price
             * and override the data of adults and children as if it was a single rooms case
             */
        const rooms = [...document.querySelectorAll('.rate-box__final-data')].map((el) => {
            const price = thn.parseNumber(el.textContent);
            // Get guest data
            const rateWrapper = el.closest('.rate-box');
            const occupancyWapper = rateWrapper && rateWrapper.querySelector('.form-group.is--hide option[selected]');
            const adults = thn.parseNumber(occupancyWapper?.getAttribute('data-adults')) || 2;
            const children = thn.parseNumber(occupancyWapper?.getAttribute('data-kids')) || 0;
            const ages = [];
            for (let i = 1; i <= children; i += 1) {
                const ageAttr = thn.parseNumber(occupancyWapper?.getAttribute(`data-age${i}`)) || 1;
                ages.push(ageAttr);
            }
            const isSoldOut = !!rateWrapper.querySelector('[id*=MyDiv].button--disabled');
            return {
                price: price,
                adults: adults,
                children: children,
                isSoldOut: isSoldOut,
                ages: ages,
            };
        }).filter((room) => !room.isSoldOut).sort((a, b) => a.price - b.price);
        const cheapestRoom = rooms[0];
        if (cheapestRoom && nights) {
            // Guests
            const roomInfo = {
                adults: cheapestRoom.adults,
                children: cheapestRoom.children,
                children_ages: cheapestRoom.ages,
            };
            widgetData.rooms_dispo = [roomInfo];
            // Price & Currency
            widgetData.price = cheapestRoom.price / nights;
            widgetData.currency = thn.objectGet(window.dataLayer, 'currency-code') || 'USD';
            widgetData.set = true;
        }
        else {
            widgetData.no_rooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_313
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const bookingWrapper = document.querySelector('.formulario .row .row > div > div');
        if (bookingWrapper) {
            const dateBegin = translateDate((bookingWrapper.querySelector('h1:nth-child(3)') || {}).textContent || '', thn.data.language);
            const dateEnd = translateDate((bookingWrapper.querySelector('h1:nth-child(4)') || {}).textContent || '', thn.data.language);
            const bookingId = thn.parseNumber((bookingWrapper.querySelector('h1:nth-child(1)') || {}).textContent || '');
            const priceText = (bookingWrapper.querySelector('#lblTotal ,p:nth-child(10)') || {}).textContent;
            // If we reaload the page, we cannot obtain the booking_id and we will duplicate a booking, we need to avoid that by unseting widget_data.set
            if (bookingId && priceText) {
                widgetData.date_begin = dateBegin;
                widgetData.date_end = dateEnd;
                widgetData.booking_id = bookingId;
                widgetData.price = thn.parseNumber(priceText);
                widgetData.currency = (priceText.match(/[^\s\d]{3}/) || [])[0] || 'MXN';
            }
            else {
                this.logger.warn('--- Cannot obtain booking ID, disabling Booking Widget ---');
                widgetData.set = false;
            }
        }
        return widgetData;
    };
    return engine;
}

export { factory };
